<template>
  <div>
    <div align="left"></div>
    <br />
    <div class="text-left">
      <b-row>
        <b-col md="3" class="my-1">
          <b-row>
            <b-col md="7" class="pr-0">
              <h4 class="font-weight-bold text-primary">Product Location</h4>
            </b-col>
            <b-col class="pt-1">
              <label
                v-if="product_location"
                class="text-gray-500 font-weight-light"
                style="cursor: pointer"
                @click="product_location = !product_location"
                >Hide</label
              >
              <label
                v-else
                class="text-primary font-weight-bold"
                style="cursor: pointer"
                @click="product_location = !product_location"
                >Show</label
              >
            </b-col>
          </b-row>
        </b-col>
        <b-col class="my-1" align="right">
          <router-link :to="{ name: 'createProductLocation' }">
            <b-button variant="primary">
              <img
                src="@/assets/create-new.svg"
                class="mr-2 action_icon"
                alt
              />Create New
            </b-button>
          </router-link>
        </b-col>
      </b-row>
      <br />
      <transition name="slide">
        <b-row v-show="product_location">
          <b-col
            v-for="data in product_location_array"
            :key="data.id"
            sm="6"
            lg="4"
            md="4"
            class="my-2"
          >
            <b-card
              @click="getDetailProductLocation(data.id)"
              style="cursor: pointer"
              v-if="product_location_array.length > 0"
            >
              <h5 class="text-primary font-weight-bold">
                {{ data.product_name }}
              </h5>
              <p>{{ data.brief_description }}</p>
            </b-card>
            <h5 v-else class="text-gray-500 text-center">Data Empty</h5>
          </b-col>
        </b-row>
      </transition>
      <br />
      <b-row class="mt-4">
        <b-col md="3" class="my-1">
          <b-row>
            <b-col md="7" class="pr-0">
              <h4 class="font-weight-bold text-primary">Payment Method</h4>
            </b-col>
            <b-col class="pt-1">
              <label
                v-if="payment_method"
                class="text-gray-500 font-weight-light"
                style="cursor: pointer"
                @click="payment_method = !payment_method"
                >Hide</label
              >
              <label
                v-else
                class="text-primary font-weight-bold"
                style="cursor: pointer"
                @click="payment_method = !payment_method"
                >Show</label
              >
            </b-col>
          </b-row>
        </b-col>
        <b-col class="my-1" align="right">
          <b-row>
            <b-col offset-md="5" class="text-right">
              <b-input-group>
                <b-input-group-text
                  class="bg-white border-right-0"
                  slot="prepend"
                >
                  <img src="@/assets/ic-groupby.svg" alt class="action_icon" />
                </b-input-group-text>
                <b-dropdown
                  text="Group By"
                  variant="light"
                  toggle-class="bg-white border-secondary text-primary border-left-0 pl-0"
                  slot="append"
                >
                  <b-dropdown-item
                    v-for="data in group_by"
                    :key="data.value"
                    @click="group(data.value)"
                  >
                    <span>{{ data.description }}</span>
                  </b-dropdown-item>
                </b-dropdown>
              </b-input-group>
            </b-col>
            <b-col class="pr-0">
              <b-button
                @click="filterShow = !filterShow"
                class="bg-white text-primary border-secondary"
              >
                <img src="@/assets/filter.svg" alt /> Filter Data
              </b-button>
            </b-col>
            <b-col class="pl-0">
              <router-link :to="{ name: 'createPaymentMethod' }">
                <b-button variant="primary">
                  <img
                    src="@/assets/create-new.svg"
                    class="mr-2 action_icon"
                    alt
                  />Create New
                </b-button>
              </router-link>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <br />
      <transition-group name="slide" tag="div">
        <div
          v-show="payment_method"
          v-for="group in payment_method_array"
          :key="group"
        >
          <h5 v-show="group.group_display" class="mb-3">
            {{ group.group_display }}
          </h5>
          <b-row>
            <b-col md="4" v-for="data in group.data" :key="data">
              <b-card class="py-2 mb-3" style="cursor: pointer">
                <b-row>
                  <b-col @click="getDetailPaymentMethod(data.id)">
                    <h4 class="text-primary font-weight-bold">
                      {{ data.display_name }}
                    </h4>
                  </b-col>
                  <b-col class="text-right">
                    Order Number :&nbsp;{{ data.order_field }}
                    <br />
                    <b-link
                      :class="{ 'order-link': data.order_field === 1 }"
                      @click="
                        orderPaymentAggregator({ id: data.id, change: 'up' })
                      "
                      class="text-primary"
                      v-b-tooltip.hover
                      title="Up Order"
                    >
                      <i class="fas fa-arrow-left mr-2"></i>
                    </b-link>
                    <b-link
                      :class="{ 'order-link': data.is_last_order }"
                      @click="
                        orderPaymentAggregator({ id: data.id, change: 'down' })
                      "
                      class="text-primary"
                      v-b-tooltip.hover
                      title="Down Order"
                    >
                      <i class="fas fa-arrow-right"></i>
                    </b-link>
                  </b-col>
                </b-row>
                <br />
                <b-row @click="getDetailPaymentMethod(data.id)">
                  <b-col class="text-center">
                    <img :src="data.logo" alt width="50%" />
                  </b-col>
                </b-row>
                <br />
                <b-row>
                  <b-col md="5" class="font-weight-bold">Payment Gateway</b-col>
                  <b-col>:&nbsp;{{ data.payment_gateway }}</b-col>
                </b-row>
                <b-row>
                  <b-col md="5" class="font-weight-bold">Payment Method</b-col>
                  <b-col>:&nbsp;{{ data.method_name }}</b-col>
                </b-row>
                <b-row>
                  <b-col md="5" class="font-weight-bold">Enabled</b-col>
                  <b-col>:&nbsp;{{ data.count_product_location_enable }}</b-col>
                </b-row>
                <b-row>
                  <b-col md="5" class="font-weight-bold">Disabled</b-col>
                  <b-col
                    >:&nbsp;{{ data.count_product_location_disable }}</b-col
                  >
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <br />
          <br />
        </div>
      </transition-group>
    </div>
    <b-modal
      v-model="detailProductShow"
      id="modal-prevent-closing"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      size="md"
    >
      <b-row>
        <b-col>
          <h5 class="text-primary font-weight-bold">
            {{ product_location_popup.product_name }}
          </h5>
        </b-col>
        <b-col md="3" class="text-right text-primary font-weight-bold">
          <router-link
            class="text-decoration-none"
            v-show="!LoadingPopupProductLocation"
            :to="{
              name: 'editProductLocation',
              params: { id: product_location_popup.product_location_id },
            }"
          >
            <i class="fas fa-edit"></i>&nbsp; Edit
          </router-link>
        </b-col>
      </b-row>
      <br />
      <b-spinner
        label="Spinning"
        v-show="LoadingPopupProductLocation"
      ></b-spinner>
      <div v-show="!LoadingPopupProductLocation">
        <b-row>
          <b-col md="4">Brief Description</b-col>
          <b-col>: &nbsp;{{ product_location_popup.brief_description }}</b-col>
        </b-row>
        <b-row>
          <b-col md="4">Used On</b-col>
          <b-col>
            <b-row
              v-for="data in product_location_popup.payment_methods"
              :key="data"
            >
              <b-col>: &nbsp;{{ data.display_name }}</b-col>
              <b-col class="text-right">
                <b-form-checkbox
                  v-model="data.is_enable"
                  name="check-button"
                  switch
                ></b-form-checkbox>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <br />

      <br />
      <b-row>
        <b-col>
          <b-button
            variant="light"
            @click="detailProductShow = !detailProductShow"
            class="text-primary"
            block
            :disabled="LoadingPopupProductLocation"
            size="lg"
            >Closed</b-button
          >
        </b-col>
        <b-col>
          <b-button
            variant="primary"
            :disabled="loadingProductEnable || LoadingPopupProductLocation"
            @click="updateProductLocationEnable()"
            block
            size="lg"
          >
            <b-spinner
              label="Spinning"
              v-show="loadingProductEnable"
            ></b-spinner
            >Save
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      v-model="detailMethodShow"
      id="modal-prevent-closing"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      size="md"
    >
      <b-row>
        <b-col>
          <h5 class="text-primary font-weight-bold">
            {{ payment_method_popup.display_name }}
          </h5>
        </b-col>
        <b-col md="3" class="text-right text-primary font-weight-bold">
          <router-link
            v-show="!LoadingPopupPaymentMethod"
            class="text-decoration-none"
            :to="{
              name: 'editPaymentMethod',
              params: { id: payment_method_popup.payment_method_id },
            }"
          >
            <a class="disabled"> <i class="fas fa-edit"></i>&nbsp; Edit </a>
          </router-link>
        </b-col>
      </b-row>
      <br />
      <b-spinner
        label="Spinning"
        v-show="LoadingPopupPaymentMethod"
      ></b-spinner>
      <div v-show="!LoadingPopupPaymentMethod">
        <b-row>
          <b-col md="4">Payment Gateway</b-col>
          <b-col>: &nbsp;{{ payment_method_popup.payment_gateway }}</b-col>
        </b-row>
        <b-row>
          <b-col md="4">Payment Method</b-col>
          <b-col>: &nbsp;{{ payment_method_popup.method_name }}</b-col>
        </b-row>
        <b-row>
          <b-col md="4">Product</b-col>
          <b-col>
            <b-row
              v-for="data in payment_method_popup.payment_method_product_locations"
              :key="data"
            >
              <b-col>: &nbsp;{{ data.product_location_name }}</b-col>
              <b-col class="text-right">
                <b-form-checkbox
                  v-model="data.is_enable"
                  name="check-button"
                  switch
                ></b-form-checkbox>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <br />

      <br />
      <b-row>
        <b-col>
          <b-button
            variant="light"
            @click="detailMethodShow = !detailMethodShow"
            class="text-primary"
            block
            :disabled="LoadingPopupPaymentMethod"
            size="lg"
            >Closed</b-button
          >
        </b-col>
        <b-col>
          <b-button
            variant="primary"
            :disabled="loadingPaymentEnable || LoadingPopupPaymentMethod"
            @click="updatePaymentMethodEnable()"
            block
            size="lg"
          >
            <b-spinner
              label="Spinning"
              v-show="loadingPaymentEnable"
            ></b-spinner
            >Save
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      v-model="filterShow"
      id="modal-prevent-closing"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      size="md"
    >
      <!-- <h4>Kirim ke Email</h4> -->
      <br />
      <b-row>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label="Payment Method"
            class="font-weight-bold"
            label-for="input-1"
          >
            <input
              v-validate="'required'"
              v-model="filter"
              name="filter"
              data-vv-as="Payment Method"
              id="input-1"
              class="form-control"
              placeholder="Search Payment Method"
            />
            <b-form-invalid-feedback id="input-filter-feedback">{{
              veeErrors.first("filter")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Payment Gateway">
            <b-form-checkbox-group
              id="checkbox-group-2"
              v-model="filter_payment_method"
              name="flavour-2"
            >
              <b-form-checkbox
                v-for="data in payment_method_array_list"
                :key="data"
                :value="data"
                >{{ data }}</b-form-checkbox
              >
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Type">
            <b-form-checkbox-group
              id="checkbox-group-2"
              v-model="filter_type"
              name="flavour-2"
            >
              <b-form-checkbox
                v-for="data in all_type"
                :value="data.value"
                :key="data"
                >{{ data.description }}</b-form-checkbox
              >
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Product">
            <b-form-checkbox-group
              id="checkbox-group-2"
              v-model="filter_product_location"
              name="flavour-2"
            >
              <b-form-checkbox
                v-for="data in product_location_array"
                :key="data"
                :value="data.id"
                >{{ data.product_name }}</b-form-checkbox
              >
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <b-button
            variant="light"
            @click="resetFilter()"
            class="text-primary border-secondary"
            block
            size="lg"
            >Reset</b-button
          >
        </b-col>
        <b-col md="6" align-self="right" class="text-right">
          <b-button
            variant="primary"
            :disabled="loadingEmail"
            @click="filterNew()"
            block
            size="lg"
          >
            <b-spinner label="Spinning" v-show="loadingEmail"></b-spinner>Apply
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      all_type: [],
      filterShow: false,
      checked: true,
      product_location: true,
      payment_method: true,
      LoadingPopupProductLocation: false,
      LoadingPopupPaymentMethod: false,
      loadingPaymentEnable: false,
      loadingProductEnable: false,
      detailMethodShow: false,
      detailProductShow: false,
      loading: false,
      errored: false,
      id_product: 1,
      id_method: 1,
      filter_payment_method: [],
      filter_type: [],
      filter_product_location: [],
      product_location_array: [],
      payment_method_array: [],
      payment_method_array_list: [],
      items: [],
      group_by: [],
      payment_method_popup: [],
      product_location_popup: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: "",
      customerShow: false,
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    rows() {
      return this.items.length;
    },
  },
  beforeCreate() {
    const formData = new FormData();
    formData.append("search_param", "");
    formData.append("limit", "1000");
    formData.append("page", "1");
    formData.append("sort_by", "");
    formData.append("is_sort_asc", true);
    this.$store
      .dispatch("PaymentMethodModule/getProductLocations", formData)
      .then((response) => {
        this.product_location_array = response.results;
        this.loading = false;
      })
      .catch((error) => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        this.loading = false;
      });
    this.$store
      .dispatch("PaymentMethodModule/getPaymentMethods", formData)
      .then((response) => {
        this.payment_method_array = response.results;
        this.loading = false;
      })
      .catch((error) => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        this.loading = false;
      });
    this.$store
      .dispatch("PaymentMethodModule/getPaymentMethodsList")
      .then((response) => {
        this.payment_method_array_list = response;
        this.loading = false;
      })
      .catch((error) => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        this.loading = false;
      });
    this.$store.dispatch("PaymentMethodModule/getAllGroupBy");
    this.$store.dispatch("PaymentMethodModule/getAllType");
  },
  created() {
    this.$store.watch(
      (state) => state.PaymentMethodModule.group_by,
      (newValue, oldValue) => {
        this.group_by = newValue;
      }
    );
    this.$store.watch(
      (state) => state.PaymentMethodModule.payment_method_popup,
      (newValue, oldValue) => {
        this.payment_method_popup = newValue;
      }
    );
    this.$store.watch(
      (state) => state.PaymentMethodModule.product_location_popup,
      (newValue, oldValue) => {
        this.product_location_popup = newValue;
      }
    );
    this.$store.watch(
      (state) => state.PaymentMethodModule.all_type,
      (newValue, oldValue) => {
        this.all_type = newValue;
      }
    );
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  methods: {
    resetFilter() {
      this.filterShow = !this.filterShow;
      this.filter = "";
      this.filter_payment_method = [];
      this.filter_type = [];
      this.filter_product_location = [];
      const formData = new FormData();
      formData.append("search_param", "");
      formData.append("limit", "1000");
      formData.append("page", "1");
      formData.append("sort_by", "");
      formData.append("is_sort_asc", true);
      this.$store
        .dispatch("PaymentMethodModule/getPaymentMethods", formData)
        .then((response) => {
          this.payment_method_array = response.results;
          this.loading = false;
        })
        .catch((error) => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.loading = false;
        });
    },
    refresh() {
      this.filter = "";
      this.filter_payment_method = [];
      this.filter_type = [];
      this.filter_product_location = [];
      const formData = new FormData();
      formData.append("search_param", "");
      formData.append("limit", "1000");
      formData.append("page", "1");
      formData.append("sort_by", "");
      formData.append("is_sort_asc", true);
      this.$store
        .dispatch("PaymentMethodModule/getPaymentMethods", formData)
        .then((response) => {
          this.payment_method_array = response.results;
          this.loading = false;
        })
        .catch((error) => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.loading = false;
        });
    },
    group(payload) {
      const formData = new FormData();
      formData.append("search_param", "");
      formData.append("limit", "1000");
      formData.append("page", "1");
      formData.append("sort_by", "");
      formData.append("is_sort_asc", true);
      formData.append("group_by", payload);
      this.$store
        .dispatch("PaymentMethodModule/getPaymentMethods", formData)
        .then((response) => {
          this.payment_method_array = response.results;
          this.loading = false;
        })
        .catch((error) => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.loading = false;
        });
    },
    filterNew(payload) {
      const formData = new FormData();
      formData.append("search_param", this.filter);
      formData.append("limit", "1000");
      formData.append("page", "1");
      formData.append("sort_by", "");
      formData.append("is_sort_asc", true);
      $.each(this.filter_payment_method, (key, value) => {
        formData.append("payment_gateway", value);
      });
      $.each(this.filter_type, (key, value) => {
        formData.append("type", value);
      });
      $.each(this.filter_product_location, (key, value) => {
        formData.append("product_location_id", value);
      });
      this.$store
        .dispatch("PaymentMethodModule/getPaymentMethods", formData)
        .then((response) => {
          this.payment_method_array = response.results;
          this.filterShow = false;
        })
        .catch((error) => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.filterShow = false;
        });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getDetailPaymentMethod(id) {
      this.detailMethodShow = true;
      this.LoadingPopupPaymentMethod = true;
      this.$store
        .dispatch("PaymentMethodModule/getPaymentMethodPopup", id)
        .then((response) => {
          this.LoadingPopupPaymentMethod = false;
          console.log(response);
        })
        .catch((error) => {
          this.LoadingPopupPaymentMethod = false;
          var message = error.response.data.data.toString();
          this.$swal({
            type: "error",
            title: "Oops...",
            text: message,
            showConfirmButton: false,
            timer: 1500,
          });
          console.log(error);
        });
    },
    updatePaymentMethodEnable() {
      this.loadingPaymentEnable = true;
      this.$swal({
        title: "Are you sure?",
        text: "Change Payment Method Used On?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Change it!",
      }).then((result) => {
        if (result.value) {
          const formData = new FormData();
          $.each(
            this.payment_method_popup.payment_method_product_locations,
            (index, value) => {
              formData.append("sequence", index);
              formData.append(
                `payment_method_id[${index}]`,
                this.payment_method_popup.payment_method_id
              );
              formData.append(
                `product_location_id[${index}]`,
                value.product_location_id
              );
              formData.append(`is_enable[${index}]`, value.is_enable);
            }
          );
          this.$store
            .dispatch("PaymentMethodModule/updateAllIsEnable", formData)
            .then((response) => {
              this.loadingPaymentEnable = false;
              this.detailMethodShow = false;
              this.$router.push({ name: "PaymentMethod" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(response);
            })
            .catch((error) => {
              this.loadingPaymentEnable = false;
              var message = error.response.data.data.toString();
              console.log(message);
              this.$swal({
                type: "error",
                title: "Oops...",
                text: message,
                showConfirmButton: false,
                timer: 1500,
              });
              this.serverError = error.response.data;
              console.log(error);
            });
        } else {
          this.loadingPaymentEnable = false;
        }
      });
    },
    getDetailProductLocation(id) {
      this.detailProductShow = true;
      this.LoadingPopupProductLocation = true;
      this.$store
        .dispatch("PaymentMethodModule/getProductLocationPopup", id)
        .then((response) => {
          this.LoadingPopupProductLocation = false;
          console.log(response);
        })
        .catch((error) => {
          this.LoadingPopupProductLocation = false;
          var message = error.response.data.data.toString();
          this.$swal({
            type: "error",
            title: "Oops...",
            text: message,
            showConfirmButton: false,
            timer: 1500,
          });
          console.log(error);
        });
    },
    updateProductLocationEnable() {
      this.loadingProductEnable = true;
      this.$swal({
        title: "Are you sure?",
        text: "Change Product Location Used On?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Change it!",
      }).then((result) => {
        if (result.value) {
          const formData = new FormData();
          $.each(
            this.product_location_popup.payment_methods,
            (index, value) => {
              formData.append("sequence", index);
              formData.append(
                `payment_method_id[${index}]`,
                value.payment_method_id
              );
              formData.append(
                `product_location_id[${index}]`,
                this.product_location_popup.product_location_id
              );
              formData.append(`is_enable[${index}]`, value.is_enable);
            }
          );
          this.$store
            .dispatch("PaymentMethodModule/updateAllIsEnable", formData)
            .then((response) => {
              this.loadingProductEnable = false;
              this.detailProductShow = false;
              this.$router.push({ name: "PaymentMethod" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(response);
            })
            .catch((error) => {
              this.loadingProductEnable = false;
              var message = error.response.data.data.toString();
              console.log(message);
              this.$swal({
                type: "error",
                title: "Oops...",
                text: message,
                showConfirmButton: false,
                timer: 1500,
              });
              this.serverError = error.response.data;
              console.log(error);
            });
        } else {
          this.loadingProductEnable = false;
        }
      });
    },
    orderPaymentAggregator(order) {
      this.loading = true;
      const orderData = {
        change_type: order.change,
      };
      this.$store
        .dispatch("PaymentMethodModule/getPaymentMethodOrder", {
          id: order.id,
          orderData,
        })
        .then((response) => {
          this.refresh();
          this.$swal({
            type: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((error) => {
          this.loading = false;
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.serverError = error.response.data;
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
u {
  text-decoration: underline;
}
</style>
